import { storeToRefs } from 'pinia'
import { usePermissionsStore } from '@/modules/auth/store/permissions.store'
import { useAuthStore } from '@/modules/auth/store/auth.store'

export function usePermissions() {
  const permissionsStore = usePermissionsStore()
  const authStore = useAuthStore()
  const { permissions, loaded } = storeToRefs(permissionsStore)

  const isGod = () => authStore.user?.roles?.includes('God') ?? false

  const can = (permission) => {
    if (isGod()) return true
    return permissions.value.includes(permission)
  }

  const canAny = (perms) => {
    if (isGod()) return true
    return perms.some(p => permissions.value.includes(p))
  }

  return {
    permissions,
    loaded,
    can,
    canAny
  }
}